import { render, staticRenderFns } from "./CollectionCaseItem.vue?vue&type=template&id=7cf560c1&"
import script from "./CollectionCaseItem.vue?vue&type=script&lang=js&"
export * from "./CollectionCaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports